export default __webpack_public_path__ + "static/media/automation.6abc1400.png";